import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { UI_NAMESPACE } from '../../../i18n';
import { cn } from '../../../lib/utils';
import { Button } from '../../ui/button';
/**
 * X di chiusura. Come bottone ha sempre un nome accessibile: «Chiudi» di
 * default (`ui:dialog.close`), sostituibile con `aria-label`. Un bottone
 * con la sola icona non dice al lettore di schermo cosa fa.
 */
export function XCloseIcon({ asButton = false, className, children, onClick, ...props }) {
    const { t } = useTranslation(UI_NAMESPACE);
    const mergedClassName = cn('p-0! h-auto aspect-square shadow-none rounded bg-transparent hover:bg-black/30 transition-all cursor-pointer flex items-center justify-center *:data-icon:size-5!', className);
    const handleClick = (e) => {
        if (onClick)
            onClick(e);
    };
    return asButton ? (_jsxs(Button, { className: mergedClassName, onClick: handleClick, "aria-label": children ? undefined : t('dialog.close'), ...props, children: [_jsx(X, { "data-icon": true }), children] })) : (_jsx("div", { className: mergedClassName, onClick: handleClick, children: _jsx(X, { "data-icon": true, ...props }) }));
}
//# sourceMappingURL=index.js.map